import React, { useEffect } from "react";
import { Heart, TrashIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { removeFromWishlist, setWishlist } from "../../Redux/WishlistSlice";
import { Wish } from "../../api/urls";
import useFetch from "../../hooks/useFetch";
import { api } from "../../api/api";
import { toast } from "react-toastify";
// import { add } from "../../Redux/CartSlice";
const WishlistPage = () => {
  const { data: wishlist, refetch } = useFetch(Wish);
  // const wishlist = useSelector((state) => state.wishlist);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setWishlist(wishlist));
  }, [dispatch, wishlist]);

  const handleRemoveItem = async (id) => {
    try {
      await api.delete(Wish + `${id}/`);
      refetch();
      dispatch(removeFromWishlist(id));
      toast.success("Product removed from wishlist");
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  if (wishlist && wishlist?.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "3rem",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Heart size={48} strokeWidth={1} />
        <h2 style={{ margin: "1rem 0 0.5rem" }}>Your wishlist is empty</h2>
        <p style={{ color: "#666", marginBottom: "1.5rem" }}>
          Save your favorite items here for later
        </p>
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          style={{
            padding: "0.75rem 1.5rem",
            backgroundColor: "black",
            color: "white",
            border: "none", // Removed border
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "1rem",
          }}
          onClick={() => navigate("/")}
        >
          Continue Shopping
        </motion.button>
      </div>
    );
  }

  return (
    <div className="max-w-[1500px] mx-auto p-5 min-h-[100vh]">
      <div className="flex justify-between items-center mb-3">
        <h1 style={{ fontSize: "1.5rem", fontWeight: "600" }}>Wishlist</h1>
        <span style={{ fontSize: "0.9rem", color: "#666" }}>
          Items ({wishlist?.length.toString().padStart(2, "0") || 0})
        </span>
      </div>

      <div className="flex flex-wrap gap-4 md:justify-start justify-center">
        {wishlist?.map((item) => (
          <motion.div
            key={item.id}
            whileHover={{ y: -5 }}
            transition={{ duration: 0.2 }}
            className="bg-white"
            onClick={() => navigate(`/products/${item.product}`)}
          >
            {/* <div
              style={{
                // width: "100%",

                overflow: "hidden",
                position: "relative",
                cursor: "pointer",
              }}
              // className="xl:w-[320px] md:w-[200px] w-[140px]"
            > */}

            <div className=" border rounded-lg md:w-[220px] w-[130px]">
              <img
                src={item.product_image}
                alt={item.product_title}
                style={{
                  // width: "100%",
                  // height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                  aspectRatio: "1/1",
                }}
                className="rounded-t-lg"
              />
              {/* </div> */}
              <div style={{ padding: "1rem", textAlign: "left" }}>
                <h3
                  onClick={() => navigate(`/products/${item.id}`)}
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "1.2",
                    textAlign: "left", // Left aligned title text
                  }}
                >
                  {item.product_title}
                </h3>
                <div style={{ marginBottom: "1rem", textAlign: "left" }}>
                  <span
                    style={{
                      display: "block",
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                    }}
                  >
                    ₹{item.country_details?.discount_price}
                  </span>
                  <span style={{ fontSize: "0.75rem", color: "gray" }}>
                    MRP incl. of all taxes
                  </span>
                </div>
                <div className="flex justify-center">
                  <motion.button
                    whileTap={{ scale: 0.95 }}
                    onClick={() => handleRemoveItem(item.id, item.product)}
                    className="flex justify-center items-center gap-2 border p-2 rounded-md w-full text-sm"
                  >
                    <TrashIcon size={16} /> Delete
                  </motion.button>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WishlistPage;
